import { useGetAnnotatorProjectsSummaryQuery } from './api/annotatorProjectsApiSlice';

interface UseAnnotatorProjectsScreenResult {
  referenceStandardReviewProjectsCount: number;
  inProgressProjectsCount: number;
  completedProjectsCount: number;
  totalProjectsCount: number;
  isProjectsSummaryLoading: boolean;
}
export const useAnnotatorProjectsScreen = (): UseAnnotatorProjectsScreenResult => {
  const {
    data: projectsSummary,
    isLoading: isProjectsSummaryLoading,
    isFetching: isProjectsSummaryFetching,
  } = useGetAnnotatorProjectsSummaryQuery();

  return {
    referenceStandardReviewProjectsCount:
      projectsSummary?.data?.referenceStandardReviewProjectsCount ?? 0,
    inProgressProjectsCount: projectsSummary?.data?.inProgressProjectsCount ?? 0,
    completedProjectsCount: projectsSummary?.data?.completedProjectsCount ?? 0,
    totalProjectsCount: projectsSummary?.data?.totalProjectsCount ?? 0,
    isProjectsSummaryLoading: isProjectsSummaryLoading || isProjectsSummaryFetching,
  };
};
